import styled from '@emotion/styled';
import { TabsWrapper } from 'src/components/Tab/Tab.style';

export const TabsWrapperLang = styled(TabsWrapper, { label: 'TabsWrapperLang' })`
    margin:  48px 0 0 10px;
`;
